import { createBrowserHistory } from "history";

export function getUrlParameterByName(
  name: string,
  url?: string
): string | undefined {
  if (typeof window !== undefined) {
    const actualUrl = url || window.location.href;

    if (!actualUrl || actualUrl.indexOf("?") === -1) {
      return undefined;
    }

    const params = actualUrl.split("?")[1].split(/(&|#)/);
    let paramValue: string | undefined;

    params.forEach((param) => {
      const keyValue = param.split("=");
      if (keyValue[0].toLowerCase() === name.toLowerCase()) {
        paramValue = decodeURIComponent(keyValue[1]);
      }
    });

    return paramValue;
  }

  return undefined;
}

export function addUrlParameterToLocation(name: string, value: string): void {
  const existingValue = getUrlParameterByName(name);
  const paramToAdd = `${name}=${encodeURIComponent(value)}`;
  const history = typeof window !== undefined && createBrowserHistory();

  if (typeof window !== undefined && history) {
    const currentPath = history.location.pathname;
    const currentParams = history.location.search;

    let newParams = currentPath;

    if (existingValue) {
      newParams = currentParams.replace(
        `${name}=${encodeURIComponent(existingValue)}`,
        paramToAdd
      );
    } else {
      if (currentParams === "") {
        newParams = `?${paramToAdd}`;
      } else {
        newParams = `${currentParams}&${paramToAdd}`;
      }
    }

    history.replace(`${currentPath}${newParams}`);
  }
}
